import React from "react";

import { countries  } from "country-flag-icons";
import ISO6391 from "iso-639-1";

import { Locale, LocaleConfig } from "@/types/i18n.types";
import { getLanguageOptions } from "@/utils/language";

export const DEFAULT_LOCALE: Locale = "en-US";

const getFlag = (languageCode: string, countryCode: string): React.ComponentType<any> | undefined=> {
  const FlagComponent = countries[countryCode as keyof typeof countries];
  const languages = getLanguageOptions();
  const currentLanguage = languages.find(l => l.code === languageCode);

  if (!currentLanguage) return undefined;

  const FlagIcon = currentLanguage.flag;
  return FlagIcon;
};

export const SUPPORTED_LOCALES: Partial<Record<Locale, LocaleConfig>> = {
  "en-US": {
    language: "en",
    region: "US",
    displayName: "English (United States)",
    nativeName: ISO6391.getNativeName("en"),
    currencyCode: "USD",
    dateFormat: "MM/DD/YYYY",
    timeFormat: "hh:mm A",
    flag: getFlag("en", "US")
  },
  "es-ES": {
    language: "es",
    region: "ES",
    displayName: "Española",
    nativeName: ISO6391.getNativeName("es"),
    currencyCode: "EUR",
    dateFormat: "DD/MM/YYYY",
    timeFormat: "hh:mm A",
    flag: getFlag("es", "ES")
  },
  "it-IT": {
    language: "it",
    region: "IT",
    displayName: "Italiano",
    nativeName: ISO6391.getNativeName("it"),
    currencyCode: "EUR",
    dateFormat: "DD/MM/YYYY",
    timeFormat: "hh:mm A",
    flag: getFlag("it", "IT")
  },
  "el-GR": {
    language: "el",
    region: "GR",
    displayName: "Greek",
    nativeName: ISO6391.getNativeName("el"),
    currencyCode: "EUR",
    dateFormat: "DD/MM/YYYY",
    timeFormat: "hh:mm A",
    flag: getFlag("el", "GR")
  }
} as const;

export const SUPPORTED_LANGUAGES = Object.values(SUPPORTED_LOCALES).map(
  config => config.language
);

export const SUPPORTED_REGIONS = Object.values(SUPPORTED_LOCALES).map(
  config => config.region
);
